<div *ngIf="heading" class="start-start-row-container padding-left-0p8 font-1 bold600">{{heading}}</div>
<div class="centered-vertically-column-container {{additionalStyle}}
  {{circle ? 'circle' : 'chart'}}">
  <span class="font-1">{{description}}</span>
</div>
